import Router from "next/router";
import { Button } from "@moneyforward/mfx_biz_react_components";

export const EditCompanyButton = () => {
  const onClick = () => {
    Router.push("/edit-company");
  };

  return (
    <Button variant="secondary" onClick={onClick}>
      編集
    </Button>
  );
};
